import { Box, Stack, Typography } from '@mui/material';
import { radius } from '@karehero/llama/theme/radius';

import type { FoundBenefit } from '@/north-star/NorthStar.fixtures';

// One benefit on the reveal screen: name + annual value, with a plain-language
// confidence pill. Rendered per found benefit.
export type BenefitRowProps = {
  benefit: FoundBenefit;
};

const BenefitRow = ({ benefit }: BenefitRowProps) => {
  const good = benefit.tone === 'good';
  return (
    <Stack
      sx={{
        alignItems: 'center',
        justifyContent: 'space-between',
        p: 2,
        bgcolor: 'background.paper',
        border: 1,
        borderColor: 'custom.neutral.200',
        borderRadius: `${radius.lg}px`,
      }}
      direction='row'
      spacing={2}
    >
      <Box sx={{ minWidth: 0 }}>
        <Typography variant='subtitle2'>{benefit.name}</Typography>
        <Box
          sx={{
            display: 'inline-flex',
            mt: 0.5,
            px: 1,
            py: 0.25,
            borderRadius: `${radius.xxl}px`,
            bgcolor: good ? 'custom.limeGreen.100' : 'custom.coral.50',
          }}
        >
          <Typography
            variant='caption'
            color={good ? 'custom.limeGreen.800' : 'custom.coral.700'}
          >
            {benefit.status}
          </Typography>
        </Box>
      </Box>
      <Box sx={{ textAlign: 'right', flexShrink: 0 }}>
        <Typography variant='subtitle1' color='custom.coral.700'>
          {benefit.annual}
        </Typography>
        <Typography variant='caption' color='text.secondary'>
          a year
        </Typography>
      </Box>
    </Stack>
  );
};

BenefitRow.displayName = 'BenefitRow';
export default BenefitRow;
